import transformToApiFormatDate from '@/utils/transformToApiDate'
import { DEFAULT_CALIFICACION_EVALUACION_DESEMPEÑO } from '@/const'

export default class DetallesEvaluacionDto {
  constructor(evaluacionDesempenioAcademico = null) {
    this.aspiranteAlPuesto = evaluacionDesempenioAcademico?.puestoAspirado || ''
    this.calificacion = evaluacionDesempenioAcademico?.calificacion || DEFAULT_CALIFICACION_EVALUACION_DESEMPEÑO
    this.fechaAplicacion = evaluacionDesempenioAcademico?.fechaAplicacion
      ? transformToApiFormatDate(evaluacionDesempenioAcademico.fechaAplicacion)
      : null
    this.fechaFin = evaluacionDesempenioAcademico?.fechaFin
      ? transformToApiFormatDate(evaluacionDesempenioAcademico.fechaFin)
      : null
    this.fechaInicial = evaluacionDesempenioAcademico?.fechaInicio
      ? transformToApiFormatDate(evaluacionDesempenioAcademico.fechaInicio)
      : null
    this.fk_idCatEstatusEvaluacion = 1
    this.fk_idCatMunicipio = evaluacionDesempenioAcademico?.idMunicipio || null
    this.fk_idPersonalEvaluador = evaluacionDesempenioAcademico?.idPersonalEvaluador || null
    this.fk_idResultado = 1
    this.institucionSeguridadAspira = evaluacionDesempenioAcademico?.institucionSeguridadAspirada || ''
    this.observaciones = evaluacionDesempenioAcademico?.observaciones || ''
    this.puntajeTotal = evaluacionDesempenioAcademico?.puntajeTotal || 0
  }

  static default() {
    return new DetallesEvaluacionDto()
  }

  static create(evaluacionDesempenioAcademico) {
    return new DetallesEvaluacionDto(evaluacionDesempenioAcademico)
  }
}
